import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Observable, of } from 'rxjs';

import { ExpandComponent } from '../..';
import { NavigationMenuService } from '../../../services';
import { MenuItem, ElementTypes, GaContext } from '../../../interfaces';

@Component({
  selector: 'fin-section-navi',
  styleUrls: ['./section-navi.component.scss'],
  templateUrl: './section-navi.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionNaviComponent {
  readonly ElementTypes = ElementTypes;
  readonly activeNaviSection$: Observable<MenuItem>;
  readonly activeNaviItem$: Observable<MenuItem>;
  readonly TRACKING_CONTEXT = GaContext.SECTION_NAVIGATION;

  @Input()
  title: string = null;

  @Input()
  showTitle$: Observable<boolean> = of(true);

  constructor(private navigationMenuService: NavigationMenuService) {
    this.activeNaviSection$ = this.navigationMenuService.activeNaviSection;
    this.activeNaviItem$ = this.navigationMenuService.activeNaviItem;
  }

  trackByIndex(index: number): number {
    return index;
  }

  toggleDetails($event: Event, expandComponent: ExpandComponent, external: boolean): void {
    if (!external) {
      expandComponent.toggleDetails($event);
    }
  }
}
